import { StackNavigationProp } from '@react-navigation/stack'
import { IconName } from '@components/base'
import Device from '@config/device'
import { ThemeColor } from '@src/style/theme'
import { AppStackParamList } from '@src/navigation/types'
import { HealthDataMeasurementType } from '@src/types.ts'

export type NavigationProp = StackNavigationProp<AppStackParamList>

export type ActionCardItem = {
  label: string
  icon: IconName
  iconColor: ThemeColor
  darkIconColor: ThemeColor
  iconBackground: ThemeColor
  onPress: (navigation: NavigationProp) => void
}

export type SyncOptionItem = {
  label: string
  backgroundColor: ThemeColor
  onPress: (navigation: NavigationProp) => void
}

export const BULLET_POINTS: { text: string; color: ThemeColor }[] = [
  { text: 'Log at least 3 meals', color: 'theme.error.base' },
  { text: 'Connect or log glucose readings', color: 'theme.success.base' },
  { text: 'Log activity or sync wearable data', color: 'theme.info.base' },
]

export const ACTION_CARDS: ActionCardItem[] = [
  {
    label: 'Log a Meal',
    icon: 'fork-knife',
    iconColor: 'theme.warning.base',
    darkIconColor: 'theme.warning.light_',
    iconBackground: 'theme.warning.lightest',
    onPress: (navigation) => navigation.navigate('AddMeal', { shouldGoBack: true }),
  },
  {
    label: 'Add Glucose Reading',
    icon: 'drop',
    iconColor: 'theme.success.darkest',
    darkIconColor: 'theme.success.light_',
    iconBackground: 'theme.success.lightest',
    onPress: (navigation) =>
      navigation.navigate('AddMeasurement', { type: HealthDataMeasurementType.Glucose }),
  },
  {
    label: 'Log Activity',
    icon: 'pulse',
    iconColor: 'theme.info.base',
    darkIconColor: 'theme.info.light_',
    iconBackground: 'theme.info.lightest',
    onPress: (navigation) => navigation.navigate('AddActivity', {}),
  },
]

const HEALTH_SYNC_OPTION: SyncOptionItem = Device.ios
  ? {
      label: 'Apple Health',
      backgroundColor: 'theme.error.base',
      onPress: (navigation) => navigation.navigate('HealthKitIntegration'),
    }
  : {
      label: 'Health Connect',
      backgroundColor: 'theme.success.base',
      onPress: (navigation) => navigation.navigate('TerraProvider', { provider: 'health_connect' }),
    }

export const SYNC_OPTIONS: SyncOptionItem[] = [
  HEALTH_SYNC_OPTION,
  {
    label: 'MyFitnessPal',
    backgroundColor: 'theme.info.base',
    onPress: (navigation) => navigation.navigate('MfpInstructions'),
  },
  {
    label: 'Oura',
    backgroundColor: 'theme.solid.black',
    onPress: (navigation) => navigation.navigate('TerraProvider', { provider: 'oura' }),
  },
]
